// pages/FormViewerPage/hooks/useFormViewer/stateCoupon.ts — state kupon (split dari state.ts)
import { useState } from 'react';

export function useCouponStates() {
    // Kupon: kode ketikan, hasil pratinjau (kode + diskon mentah dari RPC), error, loading.
    const [couponCode, setCouponCode] = useState('');
    const [couponApplied, setCouponApplied] = useState<{ code: string; rawDiscount: number } | null>(null);
    const [couponError, setCouponError] = useState('');
    const [couponApplying, setCouponApplying] = useState(false);
    return {
        couponCode, setCouponCode, couponApplied, setCouponApplied,
        couponError, setCouponError, couponApplying, setCouponApplying,
    };
}
